module.exports = __webpack_public_path__ + "img/changjing.1029e204.png";